import React, { useEffect, useMemo, useState } from 'react';
import { Button, message, Modal, Tag, Tooltip } from 'antd';
import scss from 'components/top/AiDrawer/AiDrawer.scss';
import { ze } from 'utils/zhEn';
import { AiAnalysisFeedbackType, AiAnalysisFeedbackTypeToLabel } from 'utils/constants/ai-enums';

const FEEDBACK_OPTIONS = [
  {
    value: AiAnalysisFeedbackType.CORRECT,
    label: AiAnalysisFeedbackTypeToLabel[AiAnalysisFeedbackType.CORRECT],
    color: 'green',
  },
  {
    value: AiAnalysisFeedbackType.PARTIALLY_CORRECT,
    label: AiAnalysisFeedbackTypeToLabel[AiAnalysisFeedbackType.PARTIALLY_CORRECT],
    color: 'orange',
  },
  {
    value: AiAnalysisFeedbackType.INCORRECT,
    label: AiAnalysisFeedbackTypeToLabel[AiAnalysisFeedbackType.INCORRECT],
    color: 'red',

  },
  {
    value: AiAnalysisFeedbackType.UNCLEAR,
    label: AiAnalysisFeedbackTypeToLabel[AiAnalysisFeedbackType.UNCLEAR],
  }
];

// 根据上面的FEEDBACK_OPTIONS生成一个map，方便根据value找到对应的option
const FEEDBACK_VALUE_TO_OPTION = FEEDBACK_OPTIONS.reduce((acc, option) => {
  acc[option.value] = option;
  return acc;
}, {});

const AiAnalysisFeedbackBlock = ({
  feedbackValue,
  onClickFeedback,
}) => {
  function makeButtonByOption(option, allowClick) {
    if (!option) {
      return null;
    }
    return <Tag
      key={option.value}
      color={option.color}
      style={{ cursor: allowClick ? 'pointer' : undefined, userSelect: 'none', marginRight: '16px', fontSize: '14px' }}
      onClick={() => { allowClick && onClickFeedback(option.value) }}
    >{ option.label }</Tag>;
  }

  const feedbackButtons = useMemo(() => {
    return <div>{
      FEEDBACK_OPTIONS.map((x) => {
        return makeButtonByOption(x, true);
      })
    }</div>;
  }, []);

  const selectedFeedbackOption = makeButtonByOption(FEEDBACK_VALUE_TO_OPTION[feedbackValue], false);

  return <div className={scss.aiAnalysisFeedbackBlock}>
    { !feedbackValue && <>
      <div style={{ marginBottom: '8px' }}>{ ze('您认为以上分析内容', 'What do you think of the above analysis?') }</div>
      <div>{ feedbackButtons }</div>
    </> }
    { !!feedbackValue && <>
      <div style={{ marginBottom: '8px' }}>{ ze('谢谢，我们已经收到您的反馈！', 'Thank you for your feedback!') }</div>
      <div style={{ display: 'flex', alignItems: 'center' }}>
        <div>{ ze('您的反馈是：', 'Your feedback is: ') }</div>
        <div>{ selectedFeedbackOption }</div>
      </div>
    </>}
  </div>;
};

export default AiAnalysisFeedbackBlock;
